import { render, staticRenderFns } from "./CollectionReachNumber.vue?vue&type=template&id=6d27f401&scoped=true&"
import script from "./CollectionReachNumber.vue?vue&type=script&lang=js&"
export * from "./CollectionReachNumber.vue?vue&type=script&lang=js&"
import style0 from "./CollectionReachNumber.vue?vue&type=style&index=0&id=6d27f401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d27f401",
  null
  
)

export default component.exports